import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const useGuidedTour = (
	lsTourCompletedKey,
	tourPathname
) => {
	const location = useLocation();
	const [active, setActive] = useState(false);

	const isTourCompleted = localStorage.getItem(
		lsTourCompletedKey
	);

	const isTourPath =
		location.pathname.includes(tourPathname);

	setTimeout(() => {
		if (!isTourCompleted && isTourPath) {
			return setActive(true);
		}
		return setActive(false);
	}, 2000);

	return { active };
};

export default useGuidedTour;
